declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

export enum GTMEventName {
  SIGNUP_PAGE_VIEW = 'signup_page_view',
  REGISTRATION_COMPLETE = 'registration_complete',
}

export type GTMEventProperties = Record<string, unknown>;

function getSourceLocation(): string {
  const params = new URLSearchParams(window.location.search);
  const utmSource = params.get('utm_source');
  const utmMedium = params.get('utm_medium');
  const utmCampaign = params.get('utm_campaign');

  if (utmSource || utmMedium || utmCampaign) {
    return [utmSource, utmMedium, utmCampaign].filter(Boolean).join(' / ');
  }

  if (document.referrer) {
    return document.referrer;
  }

  return 'direct';
}

const GTMService = {
  push(event: GTMEventName | string, properties: GTMEventProperties = {}) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, ...properties });
    } catch (error) {
      console.error('GTM push error');
    }
  },

  trackPageView(event: GTMEventName | string, extraProps: GTMEventProperties = {}) {
    this.push(event, {
      source_location: getSourceLocation(),
      page_path: window.location.pathname,
      page_title: document.title,
      ...extraProps,
    });
  },
};

export default GTMService;
